"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _useTags = _interopRequireDefault(require("../../../ProductDetail/hooks/useTags"));

var _Tags = _interopRequireDefault(require("../../../components/Tags"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Tags = function Tags() {
  var tags = (0, _useTags.default)();
  if ((0, _isEmpty.default)(tags)) return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "mco-shop-product-detail-tags"
  }, /*#__PURE__*/_react.default.createElement(_Tags.default, {
    tags: tags
  }));
};

var _default = Tags;
exports.default = _default;